import React, { useCallback } from "react";
import FlusterButton from "../components/FlusterButton";
import FlusterCard from "../components/FlusterCard";
import FlusterTopPlayer from "../components/FlusterTopPlayer";
import _ from "lodash";
import Socket from "socket";
const FLUSAroundTheHornResult = ({
  isAnswererPlayer,
  answererPlayer,
  aroundTheHornWinnerPlayer,
  roomId
}) => {
  const handleNextRoundAction = () => {
    if (isAnswererPlayer) {
      const data = {
        action: "update-status",
        roomId,
        tableTopName: "Fluster"
      };
      Socket.sendMessage(data);
    }
  };
  const handleNextRound = useCallback(
    _.debounce(() => handleNextRoundAction(), 1000, {
      leading: true,
      trailing: false
    }),
    []
  );

  return (
    <div className="around-the-horn-result">
      <div className="question-card-main">
        <div className="fluster-card-container">
          <FlusterCard isAroundTheHorn={true} />
        </div>
      </div>
      {isAnswererPlayer && (
        <FlusterButton text={"NEXT ROUND"} onClick={handleNextRound} />
      )}
    </div>
  );
};

export default FLUSAroundTheHornResult;
